"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (theme) => ({
    ruleDetailRow: {
        display: 'grid',
        gridTemplateColumns: '150px 1fr 1fr',
        gap: theme.spacing(2),
        alignItems: 'start',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(0.5),
    },
    ruleTypeBlock: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    ruleIcon: {
        width: 20,
        height: 20,
    },
    ruleTypeLabel: {
        color: theme.palette.text.secondary,
        textAlign: 'center',
    },
    ruleLogicBlock: {
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing(1),
    },
    ruleBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
    },
    ruleCondition: {
        backgroundColor: theme.palette.background.payeeHighlight,
        borderRadius: 4,
        padding: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
        width: 'fit-content',
        maxWidth: '100%',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
    },
    ifAndThenLabel: {
        color: theme.palette.primary.main,
        fontWeight: 500,
    },
    accountHoverText: {
        color: theme.palette.primary.main,
        cursor: 'pointer',
    },
    whiteTooltip: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.shadows[1],
        fontSize: 13,
        padding: theme.spacing(2),
        width: 'fit-content',
    },
    splitToolTip: {
        width: 'auto',
        maxWidth: 'none',
        overflowX: 'visible',
    },
    accountsInfoDiv: {
        display: 'flex',
        flexDirection: 'column',
    },
    whiteArrow: {
        color: theme.palette.background.paper,
    },
    splitTable: {
        borderCollapse: 'collapse',
        fontSize: '0.75rem',
        minWidth: 'fit-content',
    },
    splitTh: {
        textAlign: 'left',
        padding: '4px 8px',
    },
    splitTd: {
        padding: '4px 8px',
        verticalAlign: 'top',
    },
    splitAmountTd: {
        padding: '4px 8px',
        verticalAlign: 'top',
        textAlign: 'right',
    },
});
